'use strict';

/**
 * Инциализация mmenu
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector]- поиск элементов по селектору
 * @sourceCode
 */
function mMenu (selector) {
	let $menu = $(selector);
	$menu.mmenu({
		navbar: {
			title: 'Wezom'
		},
		navbars: [{
			position: 'bottom',
			height: 2,
			content: [$(selector + '-bottom').html()]
		}, true]
	});
}

function loadMenu () {
	if (typeof $.mmenu === 'undefined' && $(window).width() < 1025) {
		require.ensure([], () => {
			require('_vendors/jquery.mmenu');
			require('_vendors/mmenu.scss');
			mMenu('#js-mmenu');
		}, 'mmenu');
	}
}

(function ($) {
	loadMenu();

	$(window).resize(() => {
		loadMenu();
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/mmenu.js